import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import Badge from "components/disw/Badge";

const useStyles = makeStyles({
  badge: {
    fontFamily: "Segoe UI",
    fontWeight: 700,
    fontSize: "10px",
    lineHeight: "13px"
  },
  live: {
    backgroundColor: "#1D731C !important",
    color: "#fff !important"
  },
  unpublished: {
    backgroundColor: "#D9D9D9 !important",
    color: "#1E1E1E !important"
  }
});

export default function VersionStatusBadge({ isLive }: { isLive: boolean }) {
  const classes = useStyles();
  return (
    <Badge
      label={isLive ? "Live" : "Unpublished"}
      className={clsx(
        classes.badge,
        isLive ? classes.live : classes.unpublished
      )}
    />
  );
}
